import React from "react";

import { Box, useTheme } from "@origin-digital/ods-core";
import { IconLiveChat } from "@origin-digital/ods-icons";
import styled from "styled-components";
import { TrackedButton } from "./TrackedButton";

const ButtonWrapper = styled.div(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "right",
}));

const ButtonContainer = styled(Box)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  width: "auto",

  "& button": {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    padding: 0,
    position: "relative",
    width: "auto",

    "& svg": {
      height: theme.shape.iconSizes.xxsmall,
      width: theme.shape.iconSizes.xxsmall,
    },
  },
}));

export const chatButtonMetadata = {
  dataId: "action-bar-chat-button",
  name: "chat",
  title: "Message",
  ariaLabel: "Open messages",
} as const;

export interface ChatButtonProps {
  onClick: () => void;
  presentation: "mobile" | "desktop";
  secondaryColor?: boolean;
  showLabel?: boolean;
}

export const ChatButton = ({
  onClick,
  presentation,
  secondaryColor = false,
  showLabel = true,
}: ChatButtonProps) => {
  const { palette } = useTheme();
  const { ariaLabel, dataId, title } = chatButtonMetadata;

  return (
    <ButtonWrapper>
      <ButtonContainer
        backgroundColor={
          secondaryColor
            ? palette.backgroundColor.tertiary
            : palette.backgroundColor.grey
        }
        borderRadius="large"
        data-id={`${presentation}-chat-button`}
      >
        <TrackedButton
          aria-label={ariaLabel}
          color="secondaryB"
          data-id={dataId}
          icon={<IconLiveChat variant="solid" color="neutralDark" />}
          id={`${presentation}-chat-button`}
          muiProps={{
            style: {
              minWidth: 0,
              paddingLeft: "12px",
              paddingRight: "12px",
            },
            sx: showLabel
              ? undefined
              : {
                  "&&& .MuiButton-startIcon": {
                    marginLeft: 0,
                    marginRight: 0,
                  },
                  "&&& .MuiButton-startIcon svg": {
                    fontSize: "16px",
                  },
                },
          }}
          onClick={onClick}
          size={presentation === "mobile" ? "xsmall" : "small"}
          trackingLabel={title}
          variant="text"
        >
          {showLabel ? title : null}
        </TrackedButton>
      </ButtonContainer>
    </ButtonWrapper>
  );
};
